import {
  ADD_EXPENSIVE_ITEM,
  ADD_PACKING_WORKER,
  ADD_SET_WORKER,
  ADD_TECHNICAL_WORKER,
  ADD_WORKER,
  ASYNC_END,
  ASYNC_START,
  ASYNC_VERIFY_LOGIN,
  AUTH_CODE_ERROR,
  CHANGE_DESTINATION_ADDRESS,
  CHANGE_ORIGIN_ADDRESS,
  DESTINATION_LOCATION_SELECTED,
  END_STORE_PROFILE,
  GET_BILL,
  GET_ORDER,
  GET_PRICE,
  GET_PROFILE,
  HIDE_DELETE_ALERT,
  INVOICE_PAYED,
  IS_SELECTING_LOCATION,
  LOCATION_SELECTED,
  MINUS_DESTINATION_FLOOR,
  MINUS_ORIGIN_FLOOR,
  ORDER_CANCELED,
  ORIGIN_LOCATION_SELECTED,
  PLUS_DESTINATION_FLOOR,
  PLUS_ORIGIN_FLOOR,
  PREPARE_ORDER,
  REMOVE_INVOICE,
  REMOVE_PACKING_WORKER,
  REMOVE_SET_WORKER,
  REMOVE_TECHNICAL_WORKER,
  REMOVE_WORKER,
  RESET_STATE,
  RETRIEVE_INVOICE_LIST,
  SELECT_SERVICE,
  SEND_ORDER,
  SHOW_AUTH_ALERT,
  SHOW_ERROR_ALERT,
  SHOW_PHONE_ALERT,
  SHOW_SUCCESS_ALERT,
  SHOW_WARNING_ALERT,
  START_STORE_PROFILE,
  STORE_PROFILE,
  SUBMIT_AUTH_CODE,
  SUBMIT_ORDER,
  VERIFICATION_CODE_SENT,
  SET_SERVICE_STATUS,
  SET_MORE_SERVICES_ORDER,
  REFERRAL_OK,
  REMOVE_EXPENSIVE_ITEM,
  SET_DRIVER,
  SET_ADDRESSES,
  RESET_DESTINATION,
  TOGGLE_ELEVATOR_ORIGIN,
  TOGGLE_ELEVATOR_DEST,
  SET_TIMING,
  SET_HOURS,
  PREORDERING_PROGRESS_START,
  PREORDERING_PROGRESS_END,
  SUBMIT_ORDER_AFTER_ALL,
  SUBMITTING_ORDER,
  START_SENDING_COMMENT,
  END_SENDING_COMMENT,
  START_CHECKING_FOR_COMMENT,
  RETRIEVED_DRIVER_DATA,
  END_CHECKING_FOR_COMMENT,
  HIDE_AUTH_ALERT,
  SET_INTERCITY,
  REFINE_BILL,
  OPEN_DRAWER_MENU,
  CLOSE_DRAWER_MENU,
  SHOW_BACK_BTN,
  HIDE_BACK_BTN,
  SET_CANCEL_REASON_TEXT,
  SET_SHOW_TIME_CARD,
  CHANGE_COUPON,
  HIDE_HEADER,
  CHANGE_PROVIDER_NAME_IN_OFFER_FEEDBACK,
  CHANGE_PRICE_OFFER_FEEDBACK,
  CHANGE_DESC_OFFER_FEEDBACK,
  SHOW_PRICE_FEEDBACK_MODAL,
  CATCH_SUBMITTING_PRICE_FEEDBACK_ERRORS,
  CHANGE_REFERRAL,
  DISABLE_REFERRAL,
  CHANGE_AREA_VALUE,
  UPDATE_DRIVER_LOCATION,
  SET_EDITING_ORDER,
  SET_USER_ID,
  USER_IS_AUTHENTICATED,
  CHANGE_UTM_SOURCE,
  CHANGE_PROFILE_INPUT,
  CHANGE_RATE,
  INCREASE_STOP_TIME,
  DECREASE_STOP_TIME,
  INCREASE_WALKING,
  DECREASE_WALKING,
  SET_WORKER_VALUE,
} from "./actionsTypes";
import agent from "../agent";
import { store } from "../store";
import { createBrowserHistory } from "history";
import { push, goBack } from "connected-react-router";
import i18n from "../i18nextInitiator";
import moment from "jalali-moment";
import { useLocation } from "react-router-dom";
import { callBootApi } from "./apiCallActions";

/**
 * Translation function
 * @type {TFunction}
 */
const t = i18n.getFixedT("fa", "general");

/**
 * App page URLs.
 * @type {{order_history: string, update_order: string, worker_services: string, order_submitted: string, profile: string, comment: string, invoice: string, map: string, tracking: string, representative_invoice: string, order: string}}
 */
export const paths = {
  map: "/",
  selectDestination: "/select-destination",
  order: "/in-progress/service",
  service: "/service/:service",
  invoice: "/invoice/:id",
  order_submitted: "/services/other",
  tracking: "/invoice/:id/tracking",
  comment: "/invoice/:id/tracking/comment",
  representative_invoice: "/invoice/:id/representative",
  order_history: "/invoice/list",
  worker_services: "/services/workers",
  update_order: "/update/:order_id/:token_id",
  profile: "/profile",
  nissanAfterSubmit: "/invoice/:id/tracking/nissan",
  truckAfterSubmit: "/invoice/:id/tracking/truck",
  smallTruckAfterSubmit: "/invoice/:id/tracking/small-truck",
  preInvoice: "/invoice/:id/:serviceId",
  preInvoiceIntercity: "/invoice/:id/:serviceId/:intercity",
  trackingIntercity: "/invoice/:id/tracking/:intercity",
  referral: "/referral/:referralCode",
  game: "/game",
  gameLeaderboard: "/game/leaderboard",
  gameRules: "/game/rules",
  gamePrizes: "/game/prizes",
  midPayment: "/payment/mid",
};
/**
 * Binds parameters to a path.
 * @param id
 * @param path
 * @param serviceId
 */
export const bindingParamsToPath = (id, path, serviceId = "") =>
  path
    .replace(":id", id)
    .replace(":serviceId", serviceId)
    .replace(":intercity", "intercity");

/**
 * worker +1
 * @returns {Promise<{payload: *, type: string} | {payload, type: string} | {payload: undefined, type}>}
 */
export const addWorker = () => {
  return new Promise((resolve) => {
    resolve(store.dispatch({ type: ADD_WORKER }));
  }).then(() => store.dispatch(getPrice()));
};

/**
 * worker -1
 * @returns {Promise<{payload: *, type: string} | {payload, type: string} | {payload: undefined, type}>}
 */
export const removeWorker = () => {
  // Current State
  const { barbar_worker, origin_floor, destination_floor } =
    store.getState().order.order;
  const {
    minWorkerForPlusFiveFloors,
    smallTruckMinWorker,
    minWorker,
    smallTruckMinWorkerForPlusFiveFloors,
  } = orderingConfigValues;

  const totalFloors = origin_floor + destination_floor;

  return new Promise((resolve, reject) => {
    switch (barbar_worker) {
      case 0:
        reject("Unreasonable.");
        break;
      case minWorker:
        if (hasExpensive() && isTruck()) {
          warningAlert(t("warnings.min-workers-for-heavy-items"));
          reject("Can't decrease.");
        } else if (isTruck()) {
          warningAlert(t("warnings.min-workers-for-heavy-items"));
          reject("Can't decrease.");
        } else {
          resolve(store.dispatch({ type: REMOVE_WORKER }));
        }
        break;
      case minWorkerForPlusFiveFloors:
        if (hasTooManyFloors() && isTruck()) {
          warningAlert(t("warnings.min-workers-for-too-many-floors"));
          reject("Can't decrease.");
        } else {
          resolve(store.dispatch({ type: REMOVE_WORKER }));
        }
        break;
      case smallTruckMinWorker:
        if (hasExpensive()) {
          warningAlert(t("warnings.min-workers-for-heavy-items"));
          reject("Can't decrease.");
        } else if (!isTruck()) {
          if (hasHeavyItem() && barbar_worker === 3) {
            warningAlert(t("warnings.min-heavy"));
            reject("Can't decrease.");
          } else if (
            barbar_worker === 1 &&
            totalFloors < 4 &&
            totalFloors > 0
          ) {
            warningAlert(t("warnings.min-workers-for-too-many-floors"));
            reject("Can't decrease.");
          } else if (barbar_worker === 2 && totalFloors === 4) {
            warningAlert(t("warnings.min-workers-for-too-many-floors"));
            reject("Can't decrease.");
          } else if (barbar_worker === 3 && totalFloors > 4) {
            warningAlert(t("warnings.min-workers-for-too-many-floors"));
            reject("Can't decrease.");
          } else {
            resolve(store.dispatch({ type: REMOVE_WORKER }));
          }
        } else {
          resolve(store.dispatch({ type: REMOVE_WORKER }));
        }
        break;
      case smallTruckMinWorkerForPlusFiveFloors:
        if (hasTooManyFloors() && !isTruck()) {
          warningAlert(t("warnings.min-workers-for-too-many-floors"));
          reject("Can't decrease.");
        } else if (!isTruck()) {
          if (hasHeavyItem() && barbar_worker === 3) {
            warningAlert(t("warnings.min-heavy"));
            reject("Can't decrease.");
          } else if (
            barbar_worker === 1 &&
            totalFloors < 4 &&
            totalFloors > 0
          ) {
            warningAlert(t("warnings.min-workers-for-too-many-floors"));
            reject("Can't decrease.");
          } else if (barbar_worker === 2 && totalFloors === 4) {
            warningAlert(t("warnings.min-workers-for-too-many-floors"));
            reject("Can't decrease.");
          } else if (barbar_worker === 3 && totalFloors > 4) {
            warningAlert(t("warnings.min-workers-for-too-many-floors"));
            reject("Can't decrease.");
          } else {
            resolve(store.dispatch({ type: REMOVE_WORKER }));
          }
        } else {
          resolve(store.dispatch({ type: REMOVE_WORKER }));
        }
        break;
      default:
        if (
          isTruck() &&
          totalFloors <= 7 &&
          totalFloors >= 5 &&
          barbar_worker === 5
        ) {
          warningAlert(t("warnings.min-workers-for-too-many-floors"));
          reject("Can't decrease.");
        } else if (
          isTruck() &&
          totalFloors >= 8 &&
          totalFloors <= 11 &&
          barbar_worker === 6
        ) {
          warningAlert(t("warnings.min-workers-for-too-many-floors"));
          reject("Can't decrease.");
        } else if (isTruck() && totalFloors >= 11 && barbar_worker === 7) {
          warningAlert(t("warnings.min-workers-for-too-many-floors"));
          reject("Can't decrease.");
        } else if (!isTruck()) {
          if (hasHeavyItem() && barbar_worker === 3) {
            warningAlert(t("warnings.min-heavy"));
            reject("Can't decrease.");
          } else if (
            barbar_worker === 1 &&
            totalFloors < 4 &&
            totalFloors > 0
          ) {
            warningAlert(t("warnings.min-workers-for-too-many-floors"));
            reject("Can't decrease.");
          } else if (barbar_worker === 2 && totalFloors === 4) {
            warningAlert(t("warnings.min-workers-for-too-many-floors"));
            reject("Can't decrease.");
          } else if (barbar_worker === 3 && totalFloors > 4) {
            warningAlert(t("warnings.min-workers-for-too-many-floors"));
            reject("Can't decrease.");
          } else {
            if (barbar_worker === 1)
              warningAlert(t("warnings.min-workers-for-heavy-items"));
            else resolve(store.dispatch({ type: REMOVE_WORKER }));
          }
        } else {
          resolve(store.dispatch({ type: REMOVE_WORKER }));
        }
    }
  }).then(() => store.dispatch(getPrice()));
};

/**
 * technical worker +1
 * @returns {Promise<{payload: *, type: string} | {payload, type: string} | {payload: undefined, type}>}
 */
export const addTechnicalWorker = () => {
  return new Promise((resolve) => {
    resolve(store.dispatch({ type: ADD_TECHNICAL_WORKER }));
  }).then(() => store.dispatch(getPrice()));
};

/**
 * technical worker -1
 * @returns {Promise<{payload: *, type: string} | {payload, type: string} | {payload: undefined, type}>}
 */
export const removeTechnicalWorker = () => {
  const orderState = store.getState().order;
  return new Promise((resolve, reject) => {
    if (orderState.order.tech_worker === 0) reject("unreasnable");
    else resolve(store.dispatch({ type: REMOVE_TECHNICAL_WORKER }));
  }).then(() => store.dispatch(getPrice()));
};

export const addSetWorker = () => {
  return new Promise((resolve) => {
    resolve(store.dispatch({ type: ADD_SET_WORKER }));
  }).then(() => store.dispatch(getPrice()));
};

export const removeSetWorker = () => {
  return new Promise((resolve, reject) => {
    if (store.getState().order.order.layout_worker === 0) reject("unreasnable");
    else resolve(store.dispatch({ type: REMOVE_SET_WORKER }));
  }).then(() => store.dispatch(getPrice()));
};

export const addPackingWorker = () => {
  return new Promise((resolve) => {
    resolve(store.dispatch({ type: ADD_PACKING_WORKER }));
  }).then(() => store.dispatch(getPrice()));
};

export const removePackingWorker = () => {
  return new Promise((resolve, reject) => {
    if (store.getState().order.order.chideman_worker === 0)
      reject("unreasnable");
    else resolve(store.dispatch({ type: REMOVE_PACKING_WORKER }));
  }).then(() => store.dispatch(getPrice()));
};

export const selectService = (number) => {
  var { barbar_worker } = store.getState().order.order;
  const { truckServiceNumber, minWorker, minWorkerForPlusFiveFloors } =
    orderingConfigValues;

  return new Promise((resolve, reject) => {
    if (number === truckServiceNumber) {
      if (hasTooManyFloors() && barbar_worker < minWorkerForPlusFiveFloors)
        barbar_worker = minWorkerForPlusFiveFloors;
      else if (hasExpensive() && barbar_worker < minWorker)
        barbar_worker = minWorker;
    }
    console.log(barbar_worker);
    resolve(store.dispatch({ type: SELECT_SERVICE, number, barbar_worker: 5 }));
  }).then(() => store.dispatch(getPrice()));
};

/**
 * add heavy (expensive) item / increase it's count
 * @param number
 */
export const addExpensive = (number) => {
  store.dispatch({ type: ADD_EXPENSIVE_ITEM, number });
};
/**
 * remove heavy (expensive) item / decrease it's count
 * @param number
 */
export const removeExpensive = (number) => {
  store.dispatch({ type: REMOVE_EXPENSIVE_ITEM, number });
};

export const path = () =>
  createBrowserHistory()
    .location.pathname.replace(/[0-9]/g, "")
    .replace(/\/+$/g, "");

export const nextStep = () => {
  let newPath;
  switch (path()) {
    case `${process.env.REACT_APP_SUB_DIR}/update`:
      updateOrder();
      break;

    case `${process.env.REACT_APP_SUB_DIR}/services/workers`:
      if (!store.getState().order.inProgress) {
        store.dispatch({ type: SET_SERVICE_STATUS, status: 1 });
        store.dispatch({
          type: PREPARE_ORDER,
          userId: store.getState().auth.userId,
        });
        return sendOrder();
      }
      break;

    default:
      if (validateLocations()) return;
      newPath = paths.order;
  }

  store.dispatch(push(newPath));
};

/**
 * submit an order to show the preorder invoice.
 */
export const submitPreOrder = () => {
  if (validateAddress() || validateTime()) return;

  store.dispatch({ type: SUBMIT_ORDER_AFTER_ALL, value: true });
  if (!store.getState().auth.authenticated) {
    store.dispatch({ type: SHOW_AUTH_ALERT });
    store.dispatch({ type: SHOW_PHONE_ALERT });
  } else {
    store.dispatch({ type: PREORDERING_PROGRESS_START });
    store.dispatch({
      type: PREPARE_ORDER,
      userId: store.getState().auth.userId,
    });
    sendOrder();
  }
};

export const getPrice = () => {
  /**
   * this is a hack to handle getting price only when using Truck(کامیون)
   */
  if (
    path() === `${process.env.REACT_APP_SUB_DIR}/update` ||
    // path() === '/in-progress/time' ||
    path() === `${process.env.REACT_APP_SUB_DIR}/services/workers`
  )
    return {
      type: GET_PRICE,
      payload: agent.Order.getPrice(store.getState().order.order),
    };
  // else if(store.getState().order.order.car_id === 2)
  //     return ({type: GET_PRICE, payload: agent.Order.getPrice(store.getState().order.order)});
  else return { type: GET_PRICE, payload: undefined };
};

export const originLocationSelected = (latlng) => {
  store.dispatch({ type: IS_SELECTING_LOCATION });

  console.log("RecivedLatLng: ", latlng);

  //Remove if api gets called
  store.dispatch({ type: ORIGIN_LOCATION_SELECTED, latlng });
  store.dispatch({ type: LOCATION_SELECTED });
  store.dispatch(push(paths.selectDestination));
};

export const changeOriginAddress = (address) =>
  store.dispatch({
    type: CHANGE_ORIGIN_ADDRESS,
    address: address.target ? address.target.value : address,
  });

export const plusOriginFloor = () => {
  return new Promise((resolve, reject) => {
    resolve(store.dispatch({ type: PLUS_ORIGIN_FLOOR }));
  }).then(() => {
    handleFloorsLimit();
  });
};
export const minusOriginFloor = () => {
  return new Promise((resolve, reject) => {
    resolve(store.dispatch({ type: MINUS_ORIGIN_FLOOR }));
  }).then(() => {
    store.dispatch(getPrice());
  });
};

export const destinationLocationSelected = (latlng) => {
  store.dispatch({ type: IS_SELECTING_LOCATION });
  store.dispatch({ type: DESTINATION_LOCATION_SELECTED, latlng });
  const orderState = store.getState().order.order;

  agent.Map.reverseGeolocation({
    origin: {
      lat: orderState.startAddressLat,
      lng: orderState.startAddressLong,
    },
    destination: {
      lat: orderState.endAddressLat,
      lng: orderState.endAddressLong,
    },
  })
    .then((res) => {
      if (res && res.origin) {
        store.dispatch({ type: SET_ADDRESSES, res });
        nextStep();
      } else {
        warningAlert(t("error.out-of-service"));
      }
    })
    .catch((err) => {
      store.dispatch({ type: RESET_DESTINATION });
      warningAlert(err?.response?.body?.message);
    })
    .finally(() => store.dispatch({ type: LOCATION_SELECTED }));
};

export const changeDestinationAddress = (address) =>
  store.dispatch({
    type: CHANGE_DESTINATION_ADDRESS,
    address: address.target ? address.target.value : address,
  });

export const plusDestinationFloor = () => {
  return new Promise((resolve, reject) => {
    resolve(store.dispatch({ type: PLUS_DESTINATION_FLOOR }));
  }).then(() => {
    handleFloorsLimit();
  });
};

export const minusDestinationFloor = () => {
  return new Promise((resolve, reject) => {
    resolve(store.dispatch({ type: MINUS_DESTINATION_FLOOR }));
  }).then(() => {
    store.dispatch(getPrice());
  });
};
/**
 * Checks if floors are met the limit and applies restrictions.
 */
const handleFloorsLimit = () => {
  const {
    order: {
      order: { origin_floor, destination_floor, car_id, barbar_worker },
    },
  } = store.getState();

  const totalFloor = origin_floor + destination_floor;

  if (hasTooManyFloors()) {
    let workersNum;
    if (isTruck()) {
      workersNum = orderingConfigValues.minWorkerForPlusFiveFloors;
    } else {
      workersNum = orderingConfigValues.smallTruckMinWorkerForPlusFiveFloors;
    }

    // store.dispatch({type: SET_WORKER_VALUE, value: workersNum})
    if (
      (totalFloor === 5 || totalFloor === 8 || totalFloor === 11) &&
      isTruck()
    ) {
      warningAlert(
        t("warnings.workers-added", {
          workersNum: barbar_worker,
          floorsNum: totalFloor - 1,
        })
      );
    }
  }
};

export const checkReferral = () => {
  if (!store.getState().order.order.referral_code) return null;

  const checkReferralBody = {
    order_id: store.getState().order.bill.receiver_detail.order_id,
    referral_code: store.getState().order.order.referral_code,
  };

  return agent.Order.checkReferral(checkReferralBody).then((res) => {
    if (res.status == 200) {
      store.dispatch({ type: SHOW_SUCCESS_ALERT, message: `کد معرف اعمال شد` });
      store.dispatch({ type: REFERRAL_OK });
    } else {
      warningAlert(res.response.body.message || "خطا در برقراری ارتباط");
    }
  });
};

export const sendVerificationCode = () => {
  if (!store.getState().auth.authPhone || !store.getState().auth.correctPhone)
    return null;

  store.dispatch({
    type: VERIFICATION_CODE_SENT,
    payload: agent.Auth.phone(store.getState().auth.authPhone)
      .then((res) => {
        console.log("res");
        if (res != null && res.status === 200) return res;
        else
          store.dispatch({
            type: SHOW_ERROR_ALERT,
            message: res.message === "" ? "خطا در برقراری ارتباط" : res.message,
          });
      })

      .catch((err) => {
        console.log("err");
        store.dispatch({
          type: SHOW_ERROR_ALERT,
          message: "خطا در برقراری ارتباط",
        });
      }),
  });
};

export const submitAuthCode = (google_token) => {
  store.dispatch({ type: ASYNC_VERIFY_LOGIN, value: true });

  const { authPhone, authCode, utm_source } = store.getState().auth;

  agent.Auth.auth(authPhone, authCode, utm_source, google_token)
    .then((res) => {
      if (res) {
        if (res.status === "403") store.dispatch({ type: AUTH_CODE_ERROR });
        else if (res.status !== "200") {
          store.dispatch({ type: AUTH_CODE_ERROR });
          store.dispatch({
            type: SHOW_ERROR_ALERT,
            message: res.message === "" ? "خطا در برقراری ارتباط" : res.message,
          });
        }

        if (res.status === "200") {
          store.dispatch({ type: SUBMIT_AUTH_CODE, data: res.data });
          return res;
        }
        return null;
      }
    })
    .then((res) => {
      if (res && res.status == "200") {
        store.dispatch({
          type: SHOW_SUCCESS_ALERT,
          message: t("auth.login-successful"),
        });
        callBootApi();
      } else console.log(res);

      return res;
    })
    .finally(() => {
      store.dispatch({ type: ASYNC_VERIFY_LOGIN, value: false });
    })
    .catch((err) => {
      console.log(err);
      store.dispatch({
        type: SHOW_ERROR_ALERT,
        message: "خطا در برقراری ارتباط",
      });
    });
};

export const updateOrder = () => {
  store.dispatch({ type: ASYNC_START });
  store.dispatch({ type: PREPARE_ORDER, userId: store.getState().auth.userId });
  const order = {
    ...store.getState().order.order,
    vasayeleHazinedar: JSON.stringify({
      data: store.getState().order.order.vasayeleHazinedar,
    }),
  };
  agent.Order.update(order).then((res) => {
    if (res && res.status == 200) {
      store.dispatch({
        type: SHOW_SUCCESS_ALERT,
        message: res.message ?? "اصلاحات با موفقیت ثبت شد.",
      });
      store.dispatch(push(`/invoice/${res.data.id}/tracking`));
    } else {
      store.dispatch({
        type: SHOW_ERROR_ALERT,
        message: (res && res.message) ?? "خطای اتصال به اینترنت",
      });
    }
    store.dispatch({ type: ASYNC_END });
  });
};

export const login = () => {
  store.dispatch({ type: SHOW_AUTH_ALERT });
  store.dispatch({ type: SHOW_PHONE_ALERT });
};

export const getProfile = () => {
  agent.Profile.get(store.getState().auth.userId)
    .then((res) => {
      if (res && res.data) {
        store.dispatch({ type: GET_PROFILE, profile: res.data });
      }
      return res;
    })
    .then((res) => {
      if (
        store.getState().order.submitOrderAfterALL &&
        path() === process.env.REACT_APP_SUB_DIR + paths.order
      ) {
        submitPreOrder();
        store.dispatch({ type: SUBMIT_ORDER_AFTER_ALL, value: false });
      }
      return res;
    })
    .then((res) => {
      if (res.data.share_code) store.dispatch({ type: DISABLE_REFERRAL });
    });
};

/**
 * Submit Order.
 */
export const submitOrder = () => {
  store.dispatch({ type: SUBMITTING_ORDER, value: true });
  const { marketer, token: marketer_token } = handleMarketing() || {};
  const {
    order: {
      bill: { id: order_id, price } = {},
      order: { description, car_id },
    } = {},
  } = store.getState();
  let carIdName =
    car_id == 3
      ? "بار سبک (وانت)"
      : car_id == 1
      ? "بار سنگین (نیسان)"
      : "اثاث کشی (کامیون)";
  const submitOrderBody = {
    order_id,
    marketer,
    marketer_token,
    description,
  };

  agent.Order.submitOrder(submitOrderBody)
    .then((res) => {
      if (res && res.status == 200) {
        store.dispatch({ type: SUBMIT_ORDER });
        const id = submitOrderBody.order_id;
        if (res.data.intercity)
          store.dispatch(
            push(bindingParamsToPath(id, paths.trackingIntercity))
          );
        else
          switch (res.data.carrier_id) {
            case 1:
              store.dispatch(
                push(bindingParamsToPath(id, paths.nissanAfterSubmit))
              );
              break;
            case 2:
              store.dispatch(
                push(bindingParamsToPath(id, paths.truckAfterSubmit))
              );
              break;
            case 3:
              store.dispatch(
                push(bindingParamsToPath(id, paths.smallTruckAfterSubmit))
              );
              break;
            default:
              store.dispatch(push(bindingParamsToPath(id, paths.tracking)));
          }
      } else {
        store.dispatch({
          type: SHOW_ERROR_ALERT,
          message: res && res.message ? res.message : t("error.connection"),
        });
      }
    })
    .finally(() => {
      window.gtag("event", "checkout_progress", {
        items: [
          {
            id: car_id,
            name: carIdName,
            price: price,
          },
        ],
        coupon: marketer,
      });

      window.gtag("event", "set_checkout_option", {
        checkout_step: 2,
        checkout_option: "ثبت سفارش : تایید قیمت",
      });

      window.gtag("event", "add_to_cart", {
        items: [
          {
            id: car_id,
            name: carIdName,
            price: price,
          },
        ],
      });

      store.dispatch({ type: SUBMITTING_ORDER, value: false });
    });
};

/**
 * This function is intended to cancel the order and add a comment for the order.
 * @param comment
 */
export const cancelOrder = (comment) => {
  const {
    invoice: {
      bill: { id = "" },
    },
  } = store.getState();
  store.dispatch({ type: HIDE_DELETE_ALERT });
  const cancelOrderBody = {
    order_id: id,
    comment,
  };
  agent.Order.cancel(cancelOrderBody)
    .then((res) => {
      if (res && res.status == 200) {
        store.dispatch({ type: ORDER_CANCELED });
        store.dispatch({ type: SHOW_SUCCESS_ALERT, message: res.message });
      } else {
        store.dispatch({
          type: SHOW_ERROR_ALERT,
          message: res && res.message ? res.message : "خطا در برقراری ارتباط",
        });
      }
    })
    .finally(() => {
      doGetBill(id);
      setCancelReason(undefined);
    });
};
/**
 * Calls the api to create an order on backend.
 * @return {{payload: *, type: string}}
 */
export const sendOrder = () => {
  let orderData = store.getState().order.order;

  let carIdName =
    orderData.car_id == 3
      ? "بار سبک (وانت)"
      : orderData.car_id == 1
      ? "بار سنگین (نیسان)"
      : "اثاث کشی (کامیون)";
  return store.dispatch({
    type: SEND_ORDER,
    payload: agent.Order.send(store.getState().order.order)
      .then((res) => {
        if (res.status === "200") {
          if (path() === paths.worker_services) {
            store.dispatch({ type: SHOW_SUCCESS_ALERT, message: res.message });
            return store.dispatch(push(`/invoice/list`));
          }

          let address;
          const params = {
            id: res.data[0].id,
            serviceId: store.getState().order.order.car_id,
          };
          if (/*res.data[0].intercity*/ res.intercity && res.intercity === 1) {
            address = bindingParamsToPath(
              params.id,
              paths.preInvoiceIntercity,
              params.serviceId
            );
            store.dispatch({ type: SET_INTERCITY });
          } else
            address = bindingParamsToPath(
              params.id,
              paths.preInvoice,
              params.serviceId
            );

          store.dispatch(push(address));
          return res;
        }
        store.dispatch({ type: SHOW_ERROR_ALERT, message: res.message });
      })
      .catch((error) => {
        store.dispatch({
          type: SHOW_ERROR_ALERT,
          message: t("error.connection"),
        });
      })
      .finally(() => {
        window.gtag("event", "begin_checkout", {
          items: [
            {
              id: orderData.car_id,
              name: carIdName,
            },
          ],
        });

        window.gtag("event", "set_checkout_option", {
          checkout_step: 1,
          checkout_option: "ثبت سفارش : وارد کردن جزییات سفارش",
        });

        store.dispatch({ type: PREORDERING_PROGRESS_END });
      }),
  });
};

export const resetState = () => {
  localStorage.removeItem("state");
  localStorage.setItem("originLat", 35.700944);
  localStorage.setItem("originLng", 51.391151);
  store.dispatch({ type: RESET_STATE });
};

export const isAuthenticated = () => {
  store.dispatch({ type: "USER_IS_AUTHENTICATED" });
};

export const resetReceiver = () => {
  store.dispatch({ type: "RESET_RECEIVER" });
};

export const warningAlert = (msg) =>
  store.dispatch({ type: SHOW_WARNING_ALERT, message: msg });
export const successAlert = (message) =>
  store.dispatch({ type: SHOW_SUCCESS_ALERT, message });
export const errorAlert = (message) =>
  store.dispatch({ type: SHOW_ERROR_ALERT, message });

export const validateTime = () => {
  if (!store.getState().order.order.time) {
    setShowTimeCard(true);
    return true;
  }
  return false;
};

const validateAddress = () => {
  if (!store.getState().order.order.startAddress) {
    warningAlert(t("validation.location.warning"));
    return true;
  } else if (!store.getState().order.order.endAddress) {
    warningAlert(t("validation.location.warning-dest"));
    return true;
  } else if (
    store.getState().order.order.origin_floor === "" &&
    store.getState().order.order.destination_floor === ""
  ) {
    warningAlert(t("validation.floor.both"));
    return true;
  } else if (store.getState().order.order.origin_floor === "") {
    warningAlert(t("validation.floor.origin"));
    return true;
  } else if (store.getState().order.order.destination_floor === "") {
    warningAlert(t("validation.floor.dest"));
    return true;
  } else return false;
};

const validateLocations = () => {
  if (!store.getState().order.order.startAddressLat) {
    warningAlert(t("validation.location.warning"));
    return true;
  } else if (!store.getState().order.order.endAddressLat) {
    warningAlert(t("validation.location.warning-dest"));
    return true;
  }
};

export const storeProfile = (withoutAlert = false) => {
  store.dispatch({ type: START_STORE_PROFILE });

  let { profile, emailError } = store.getState().auth;
  if (!profile.share_code) delete profile.share_code;
  if (!profile.name) {
    store.dispatch({
      type: SHOW_ERROR_ALERT,
      message: t("validation.empty", { field: "نام" }),
    });
    return store.dispatch({ type: END_STORE_PROFILE });
  }
  if (emailError) {
    store.dispatch({
      type: SHOW_ERROR_ALERT,
      message: t("validation.wrong", { field: t("email") }),
    });
    return store.dispatch({ type: END_STORE_PROFILE });
  }

  agent.Profile.store(profile)
    .then((res) => {
      if (res.status == "200") {
        store.dispatch({ type: STORE_PROFILE });
        store.dispatch({
          type: SHOW_SUCCESS_ALERT,
          message: res.message ?? "پروفایل شما بروز شد.",
        });
      } else
        store.dispatch({
          type: SHOW_ERROR_ALERT,
          message: res.message ?? "خطا در برقراری ارتباط",
        });
    })
    .catch((error) => {
      const {
        response: {
          body: {
            errors: { share_code: { 0: shareCodeErrorMessage } = {} } = {},
          } = {},
        } = {},
      } = error;
      warningAlert(shareCodeErrorMessage);
    })
    .finally(() => {
      store.dispatch({ type: END_STORE_PROFILE });
    });
};
/**
 * retrieves order history list by calling backend api
 * @param page
 */
export const retrieveInvoiceList = (page = 1) => {
  agent.Invoice.list(page).then((res) => {
    if (res && res.data && res.data.orders)
      store.dispatch({
        type: RETRIEVE_INVOICE_LIST,
        list: res.data.orders,
        page,
      });
  });
};

export const removeInvoice = () => store.dispatch({ type: REMOVE_INVOICE });

export const getOrder = (data) =>
  store.dispatch({ type: GET_ORDER, payload: data });

export const getBill = (res) => {
  if (res.data && res.data["what?"] === "it's bill v3 mfr")
    store.dispatch({ type: GET_BILL, payload: res });
  else refineBill(res);
};

export const refineBill = (data) =>
  store.dispatch({ type: REFINE_BILL, payload: data });

export const setDriver = (data) => store.dispatch({ type: SET_DRIVER, data });

export const unPayed = () =>
  store.dispatch({ type: SHOW_ERROR_ALERT, message: "پرداخت شما انجام نشد" });

export const payed = () => {
  store.dispatch({ type: SHOW_SUCCESS_ALERT, message: "پرداخت شما انجام شد" });
  store.dispatch({ type: INVOICE_PAYED });
};

export const getLastOrderData = () => {
  agent.Invoice.bill(store.getState().order.id).then((res) => {
    if (res) getBill(res);
  });
};

export const moreServices = () => {
  store.dispatch({ type: SET_MORE_SERVICES_ORDER });
};

/**
 * Call the get bill api
 * @param id
 */
export const doGetBill = (id) => {
  agent.Invoice.bill(id).then((res) => {
    if (res) getBill(res);
  });
};

/**
 * Toggles the origin elevator value=bool.
 */
export const toggleElevatorOrigin = () => {
  store.dispatch({ type: TOGGLE_ELEVATOR_ORIGIN });
};

/**
 * Toggles the destination elevator value=bool.
 */
export const toggleElevatorDest = () => {
  store.dispatch({ type: TOGGLE_ELEVATOR_DEST });
};
/**
 * This function receives a number and returns a formatted price with currency.
 * @param number
 * @returns {string}
 */
export const formatPrice = (number) => {
  return (
    number?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
    " " +
    t("invoice.rial")
  );
};
/**
 * this function receives a unix timestamp and returns a formatted Jalali time string.
 * @param time
 * @returns {string}
 */
export const formatTime = (time) => {
  return moment(new Date(time * 1000))
    .locale("fa")
    .format(`dddd DD MMMM YYYY ${t("hour")} HH:mm`);
};
/**
 * Dispatches an action to set timings in the state.
 * @param data
 * @returns {{data: *, type: string}}
 */
export const setTiming = (data) => store.dispatch({ type: SET_TIMING, data });
/**
 * Dispatches an action to set hours of the selected day in state.
 * @param hours
 * @returns {{hours: *, type: string}}
 */
export const setHours = (hours) => store.dispatch({ type: SET_HOURS, hours });
/**
 * Receives state name string and returns order state id.
 * @param state
 * @returns {number}
 */
export const getOrderStateId = (state) => {
  switch (state) {
    /**
     * The order is submitted and awaits to get accepted by a driver.
     */
    case "submitted":
      return 1;
    /**
     * The order is assigned to a driver and awaits to get started.
     */
    case "assigned":
      return 2;
    /**
     * The shipping process has started and is in progress.
     */
    case "started":
      return 4;
    /**
     * The shipping process is finished.
     */
    case "ended":
      return 5;
    /**
     * Invoice is payed.
     */
    case "payed":
      return 6;
    /**
     * Order is cancelled.
     */
    case "cancelled":
      return 7;
    /**
     * Order is not submitted.
     */
    default:
      return 0;
  }
};

/**
 * Checks if there is a marketing token in local storage and return it.
 */
export const handleMarketing = () => {
  const marketer = localStorage.getItem("marketer");
  const token = localStorage.getItem("maToken");
  if (marketer) return { marketer, token };
};

/**
 * Check if can comment
 * @param id
 */
export const checkComment = (id) => {
  store.dispatch({ type: START_CHECKING_FOR_COMMENT });
  agent.Invoice.checkComment({ order_id: id })
    .then((res) => {
      if (res && res.status === "200") {
        /**
         * Can Comment
         */
        store.dispatch({ type: RETRIEVED_DRIVER_DATA, res });
      } else {
        /**
         * Can't Comment
         */
        store.dispatch({
          type: SHOW_ERROR_ALERT,
          message: res.message || t("error.connection"),
        });
        store.dispatch(push(bindingParamsToPath(id, paths.tracking)));
      }
    })
    .finally(() => {
      store.dispatch({ type: END_CHECKING_FOR_COMMENT });
    });
};

/**
 *      --Useless--
 *
 * Call Send Comment API
 */
export const sendComment = (comment, rank, order_id) => {
  store.dispatch({ type: START_SENDING_COMMENT });
  const props = store.getState();
  const body = {
    driver_id: props.invoice.driver && props.invoice.driver.driver_id,
    order_id,
    rank,
    comment,
  };
  agent.Invoice.sendComment(body)
    .then((res) => {
      if (res.status === "200") {
        store.dispatch({
          type: SHOW_SUCCESS_ALERT,
          message: t("rating.success-msg"),
        });
        store.dispatch(
          push(bindingParamsToPath(body.order_id, paths.tracking))
        );
      } else {
        store.dispatch({
          type: SHOW_ERROR_ALERT,
          message: res.message || t("error.connection"),
        });
      }
    })
    .finally(() => {
      store.dispatch({ type: END_SENDING_COMMENT });
    });
};

/**
 * Retrieve dimensions from window object.
 * @return {{width: number, height: number}}
 */
export const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
};
/**
 * Handles hiding the login pop
 */
export const hideAuthAlert = () => {
  store.dispatch({ type: HIDE_AUTH_ALERT });
};
/**
 * handles opening drawer menu
 * @returns {{type: string}}
 */
export const openDrawerMenu = () => store.dispatch({ type: OPEN_DRAWER_MENU });
/**
 * handles closing drawer menu
 * @returns {{type: string}}
 */
export const closeDrawerMenu = () =>
  store.dispatch({ type: CLOSE_DRAWER_MENU });
/**
 * handles showing back button
 * @returns {{type: string}}
 */
export const showBackBtn = () => store.dispatch({ type: SHOW_BACK_BTN });
/**
 * handles hiding back button
 * @returns {{type: string}}
 */
export const hideBackBtn = () => store.dispatch({ type: HIDE_BACK_BTN });
/**
 * page goes back to the last page in browser history
 * @returns {*}
 */
export const handleGoBack = () => store.dispatch(goBack());
/**
 * sets cancel order reason text to state.
 * this action gets reduced in order reducer.
 * @param value
 * @returns {{type: string, value}}
 */
export const setCancelReason = (value) =>
  store.dispatch({ type: SET_CANCEL_REASON_TEXT, value });
/**
 * sets show time card value
 * @param value
 * @returns {{type: string, value}}
 */
export const setShowTimeCard = (value) =>
  store.dispatch({ type: SET_SHOW_TIME_CARD, value });
/**
 * change discount coupon value
 * @param e
 * @returns {{coupon, type: string}}
 */
export const changeCoupon = (e) =>
  store.dispatch({ type: CHANGE_COUPON, coupon: e.target.value });
/**
 * hide app header
 * @returns {{type: string, value: boolean}}
 */
export const hideHeader = () =>
  store.dispatch({ type: HIDE_HEADER, value: true });
/**
 * unhide app header
 * @returns {{type: string, value: boolean}}
 */
export const showHeader = () =>
  store.dispatch({ type: HIDE_HEADER, value: false });
/**
 * Changes the provider name value.
 * Provider Name input is located in Offer Feedback Modal.
 * @param value
 * @returns {{type: string, value}}
 */
export const changeProviderNameInOfferModal = (e) => {
  const { invoice: { priceFeedback: { errors = {} } = {} } = {} } =
    store.getState();
  /**
   * Remove error state for provider name input
   */
  if (errors.provider)
    store.dispatch({
      type: CATCH_SUBMITTING_PRICE_FEEDBACK_ERRORS,
      value: { ...errors, provider: undefined },
    });

  store.dispatch({
    type: CHANGE_PROVIDER_NAME_IN_OFFER_FEEDBACK,
    value: e.target.value,
  });
};
/**
 * Changes the price value.
 * Thi value input is located in Offer Feedback Modal.
 * @param value
 * @returns {{type: string, value}}
 */
export const changePriceOfferModal = (e) => {
  const { invoice: { priceFeedback: { errors = {} } = {} } = {} } =
    store.getState();
  /**
   * Remove error state for price input
   */
  if (errors.price)
    store.dispatch({
      type: CATCH_SUBMITTING_PRICE_FEEDBACK_ERRORS,
      value: { ...errors, price: undefined },
    });

  store.dispatch({ type: CHANGE_PRICE_OFFER_FEEDBACK, value: e.target.value });
};
/**
 * Changes the offer feedback description value.
 * Thi value input is located in Offer Feedback Modal.
 * @param value
 * @returns {{type: string, value}}
 */
export const changeDescOfferModal = (e) =>
  store.dispatch({ type: CHANGE_DESC_OFFER_FEEDBACK, value: e.target.value });
/**
 * Show / Hide price feedback modal.
 * the price feedback modal is located in pre invoice page.
 * @param value
 * @returns {{type: string, value}}
 */
export const priceFeedbackModal = (value) =>
  store.dispatch({ type: SHOW_PRICE_FEEDBACK_MODAL, value });
/**
 * changes referral code in referral wrapper hoc.
 * @returns {{type: string, value}}
 * @param e
 */
export const changeReferralCode = (e) =>
  store.dispatch({
    type: CHANGE_REFERRAL,
    value: e.target ? e.target.value : e,
  });
/**
 * Changes the area value which is located in order page
 * @param e
 * @returns {{type: string, value: *}}
 */
export const changeAreaValue = (e) =>
  store.dispatch({
    type: CHANGE_AREA_VALUE,
    value: e.target ? e.target.value : e,
  });
/**
 * updates the driver location in tracker page
 * @param L
 * @returns {{type: string, value}}
 */
export const updateDriverLocation = (L) =>
  store.dispatch({ type: UPDATE_DRIVER_LOCATION, value: L });
/**
 * when opening update (edit) order page sets the order data into state.
 * @param order
 * @returns {{type: string, order}}
 */
export const setEditingOrder = (order) =>
  store.dispatch({ type: SET_EDITING_ORDER, order });
/**
 * stores user id in the state.
 * @param id
 * @returns {{type: string, value}}
 */
export const setUserId = (id) =>
  store.dispatch({ type: SET_USER_ID, value: id });
/**
 * is used after user is authenticated manually, so we only trigger the action to set the value of authenticated state to true
 * @returns {{type: string}}
 */
export const authenticated = () =>
  store.dispatch({ type: USER_IS_AUTHENTICATED });
/**
 * @returns {URLSearchParams}
 * URLSearchParams has a get function which helps to get parameters form url.
 */
export const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};
/**
 * Change Utm source in authentication states/reducer.
 * @param value
 * @returns {{type: string, value}}
 */
export const changeUtmSource = (value) =>
  store.dispatch({ type: CHANGE_UTM_SOURCE, value });
/**
 *
 * @param e
 * @returns {{name, type: string, value}}
 */
export const changeProfileInput = (e) =>
  store.dispatch({
    type: CHANGE_PROFILE_INPUT,
    value: e.target.value,
    name: e.target.name,
  });
/**
 * changes the rate in rating component which rates a completed order.
 * @param workerId
 * @param rate
 * @returns {{rate, type: string, worker_id}}
 */
export const changeRate = (workerId, rate) =>
  store.dispatch({ type: CHANGE_RATE, rate, workerId });
/**
 * check if there's a jwt item in local storage,
 * then set it and call isAuthenticated() actionCreator.
 */
export const boot = () => {
  const token = window.localStorage.getItem("jwt");
  if (token) {
    agent.setToken(token);
    isAuthenticated();
    const userId = window.localStorage.getItem("user_id");
    store.dispatch({ type: SET_USER_ID, value: userId });
    callBootApi();
  }
};

/**
 * functions to handle increasing/decreasing stop time for order
 */
export const increaseStopTime = () =>
  store.dispatch({ type: INCREASE_STOP_TIME });
export const decreaseStopTime = () =>
  store.dispatch({ type: DECREASE_STOP_TIME });

/**
 * functions to handle increasing/decreasing "on foot carrying" (walking) for order
 */
export const increaseWalking = () => store.dispatch({ type: INCREASE_WALKING });
export const decreaseWalking = () => store.dispatch({ type: DECREASE_WALKING });
/**
 * redirects client to tracking page if is not in the update / tracking / representative(صفحه‌فاکتور)
 * @param id
 */
export const redirectToTracking = (id) => {
  const includes =
    path().includes("update") ||
    path().includes("tracking") ||
    path().includes("representative") ||
    path().includes("game");
  if (!includes) store.dispatch(push(bindingParamsToPath(id, paths.tracking)));
};

export const orderingConfigValues = {
  // The number associated to use truck.
  truckServiceNumber: 2,
  // Minimum quantity to choose for big truck orders when using heavy items.
  minWorker: 4,
  // This limit is used to add more workers for order.
  floorsLimit: 4,
  // Minimum number to choose for big truck orders when there is more that five floors in both destination and origin building.
  minWorkerForPlusFiveFloors: 5,
  // Minimum quantity to choose for small truck orders when using heavy items.
  smallTruckMinWorker: 2,
  // The period to add and remove when selecting stop time.
  stopTimePeriod: 15,
  // The portion (meter) to add and remove when selecting on foot carrying (walking).
  walkingPortion: 10,
  // Minimum number to choose for small truck orders when there is more that five floors in both destination and origin building.
  smallTruckMinWorkerForPlusFiveFloors: 3,
};
/**
 * This function determines if there is heavy item added by the user.
 * @returns {boolean}
 */
export const hasExpensive = () => {
  var hasExpensive = false;
  store.getState().order.order.vasayeleHazinedar.map((obj) => {
    if (obj.count > 0) hasExpensive = true;
  });
  return hasExpensive;
};
/**
 * Determines if the sum of the selected floors is more than the limit number.
 * @returns {boolean}
 */
export const hasTooManyFloors = () => {
  const { origin_floor, destination_floor } = store.getState().order.order;
  return origin_floor + destination_floor > orderingConfigValues.floorsLimit;
};
/**
 * Determines if the selected service type is a big truck (کامیون)
 * @returns {boolean}
 */
export const isTruck = () =>
  orderingConfigValues.truckServiceNumber ===
  store.getState().order.order.car_id;

export const setTruckWorkers = (totalFloors) => {
  // store.dispatch({type: SET_WORKER_VALUE, value: serviceNumber === 2 ? 4 : 0})

  if (isTruck()) {
    store.dispatch({
      type: SET_WORKER_VALUE,
      value:
        totalFloors >= 0 && totalFloors <= 4
          ? 4
          : totalFloors > 4 && totalFloors <= 7
          ? 5
          : totalFloors > 7 && totalFloors <= 11
          ? 6
          : totalFloors > 11
          ? 7
          : 4,
    });
  }
  if (!isTruck()) {
    store.dispatch({
      type: SET_WORKER_VALUE,
      value:
        hasHeavyItem() > 0
          ? 3
          : totalFloors >= 1 && totalFloors <= 3
          ? 1
          : totalFloors === 4
          ? 2
          : totalFloors > 4
          ? 3
          : totalFloors === 0
          ? 1
          : 1,
    });
  }
};

export const hasHeavyItem = () => {
  const { vasayeleHazinedar } = store.getState().order.order;
  let hasHeavy = false;
  vasayeleHazinedar.forEach((element) => {
    if (element.count >= 1) {
      hasHeavy = true;
    }
  });
  return hasHeavy;
};
